<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="报批方ID" :value="1"></el-option>
                            <el-option label="报批方名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>                
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/approval/management/edit')" type="primary" icon="el-icon-plus" size="small"  @click="$refs.add.show()">创建报批方</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                
                <el-table-column prop="id" label="报批方ID"></el-table-column>
                <el-table-column label="报批方名称"  prop="companyName" ></el-table-column>               
                <el-table-column prop="createTime" label="创建时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/performer/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
							@click="$refs.add.show(scope.row)"
                            >编辑</el-button
                        >
						<el-link :href="`/activityManage/activity/list?btype=13&bvalue=${scope.row.id}`" target="_blank" size="mini" icon="el-icon-link" class="ML10">查看绑定演出</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>        
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
		<Add ref="add" @onUpdate="getDataList"></Add>
    </div>
</template>

<script>
import Add from './components/add.vue'
const defaultParams = {
    pageNo:1,
    searchType: 1,
    searchValue: '',
}
export default {
    components:{Add},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
            },
            listLoading: false,    
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            
        }
    },
    created(){
       
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params
            }
            this.$request({
                url: "/approval/management/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //注销
        del(id){
            this.$confirm('小站注销后前端不会展示,但是不影响用户购买的订单', '提示', {
                type: 'warning',
                center: true,
                confirmButtonText:'前往注销',
                cancelButtonText:'暂不注销',
                closeOnClickModal: false
            }).then(() => {
                this.$router.push({
                    path:'/user/punish/list',
                    query:{id:id}
                })
            }).catch(() => {})
        },
        //编辑、查看详情
        edit(id){
            this.$router.push({
                path: `/user/artist/edit/baseInfo/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    }
}
</script>


<style lang="scss" scoped>
.el-table{
    .el-link{
        font-size: 12px;
        margin-left:10px;
    }
}
.avatar{
    text-align: center;
    .el-image{
        width: 100px;
        margin-bottom: 10px;
    }
}
.el-link.el-link--default{
	color:#1fbb7d;
	
}

</style>